import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';

import { UserService } from '../user.service';
import {  ViewChild, ElementRef, Renderer2  } from '@angular/core';
@Component({
  selector: 'echexpayment-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})



export class RegisterComponent implements OnInit, OnDestroy {
	register: any = {'industry_type': '' };
	busy: Subscription;
	public mask: Array<string | RegExp>;
	public validationFirstname : boolean=false;
	public validationLastname : boolean=false;
	public validationBusinessname : boolean=false;
	public validationIndustrytype : boolean=false;
	public validationEmail : boolean=false;
	public invalidEmail : boolean=false;
	public validationPhone : boolean=false;
	public validationCountry_code : boolean=false;
	public match : boolean=false;
	public minPassword : boolean=false;
	public userId :string;
	public confirmpasswod : string;
  NamecharacterLimitReached: { [key: string]: boolean } = {};
  
  constructor(private userService: UserService, private elementRef: ElementRef, private renderer: Renderer2, private toastr: ToastrService, private router: Router, private route: ActivatedRoute) { 
	this.mask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];

  }
 
  ngOnDestroy() {
    this.toastr.clear();
  }

  ngOnInit() {
    this.register.country_code = "+1";
	  this.getUserData();
  }

  ngAfterViewInit() {
    this.renderer.selectRootElement('#first_name').focus();
  }

  

  // + country code in phone field
  validateInput(event: any): void {
    const inputValue = event.target.value;
    const firstChar = inputValue.charAt(0);
    const keyCode = event.keyCode || event.which;
  
    // Allow only numeric digits (0-9) and backspace/delete keys
    if (keyCode < 48 || keyCode > 57) {
      event.preventDefault();
    }
    
    // Limit the input length to 4 characters
    if (inputValue.length >= 4 && keyCode !== 8 && keyCode !== 46) {
      event.preventDefault();
    }
    
    // Make the first character read-only "+"
    if (inputValue.length === 0) {
      event.target.value = "+";
    }
  }
  
  handleInputChange(event: any): void {
    let inputValue = event.target.value;
    const firstChar = inputValue.charAt(0);
    // If the input value is empty or contains non-numeric characters, reset the input value with "+"
    if (!inputValue || !(/^\+\d*$/.test(inputValue))) {
      event.target.value = "+";
    }
    // Check if the first character is "0"
    if (firstChar === "0") {
      // Remove the "0" from the input value
      inputValue = inputValue.substring(1);
      event.target.value = "+" + inputValue;
    }
  }
  // End + country code in phone field

  focusFirstInvalidControlPlus(): void {
    const firstElementWithErrors: HTMLElement = this.elementRef.nativeElement.querySelector(`form .ng-invalid`);
    if (firstElementWithErrors) {
        firstElementWithErrors.focus();
    }
  }

   @ViewChild('submitButton') submitButton: ElementRef;
  moveNext(nextInput: HTMLInputElement, checkbox: number) {
    if(checkbox === 2){
      if (this.submitButton && this.submitButton.nativeElement) {
        this.submitButton.nativeElement.focus();
        this.submitButton.nativeElement.click();
      }
    } else{
      nextInput && nextInput.focus();
    }
  }

  // Get user data using token when super admin invites
  getUserData(){
	let params: any = this.route.snapshot.params;
	if(params.user_token){
	   let data= {
			user_token : params.user_token
		};
		let registerData = <any>{};
		this.busy =  this.userService.getUserDataApi(data).subscribe(
		   response => {
			registerData = response;
			this.register = registerData.data;
			this.userId = this.register.data._id;
		   },
		   error => {
			registerData = error;
			this.toastr.error(registerData.error.message, 'Failed!');
		   }
		);
	}
  }
  eventHandler() {
    this.validationFirstname = false;
    this.validationLastname = false;
    this.validationBusinessname = false;
    this.validationIndustrytype = false;
    this.validationEmail = false;
    this.invalidEmail = false;
    this.validationPhone = false;
    this.validationCountry_code = false;
    this.match = false;
    this.minPassword = false;
  }
  
  // Inside your component class
  testPattern(input: string, pattern: RegExp): boolean {
    return pattern.test(input);
  }

  togglePasswordVisibility(inputName: string) {
    const passwordInput = document.querySelector(`input[name="${inputName}"]`);
    const passwordToggle = passwordInput.nextElementSibling.querySelector('i');
  
    if (passwordInput.getAttribute('type') === 'password') {
      passwordInput.setAttribute('type', 'text');
      passwordToggle.classList.remove('fa-eye');
      passwordToggle.classList.add('fa-eye-slash');
    } else {
      passwordInput.setAttribute('type', 'password');
      passwordToggle.classList.remove('fa-eye-slash');
      passwordToggle.classList.add('fa-eye');
    }
  }
  

  
  
  
  userRegister(data) {
    this.focusFirstInvalidControlPlus();   //focus field
    if (data.value.password !== data.value.confirm_password) {
      this.confirmpasswod = 'Password and Confirm password do not match';
      return;
    }
    if(data.valid){
    
    let model: any = data.value;
    let params: any = this.route.snapshot.params;
    if( params.user_token){
        model.user_token = params.user_token;
        model.id =  this.userId
    }
   let responseData = <any>{};
   this.busy =  this.userService.createRegister(model).subscribe(
       response => {
        this.router.navigate(['/thank-you']);
       },
       error => {
	    responseData = error;
        this.toastr.error(responseData.error.message, 'Failed!');
       }
    );
  }
}

  NameCharacterLimit(event: any, fieldName: string, max_length:number) {
    const maxTextLength = max_length; // Maximum text length of 20 characters
    const inputChar = event.key;
    const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter'];
    const allowedKeyCodes = [46, 8, 9, 27, 13, 37, 39]; // Backspace, Delete, Tab, Escape, Enter

    if (allowedKeys.indexOf(event.key) !== -1 || allowedKeyCodes.indexOf(event.keyCode) !== -1) {
        return;
    }

    const inputValue = event.target.value;

    if (inputValue.length >= maxTextLength) {
        if (allowedKeys.indexOf(inputChar) === -1) {
            this.NamecharacterLimitReached[fieldName] = true; // Set the validation flag to true to show the warning message
            setTimeout(() => {
            this.NamecharacterLimitReached[fieldName] = false; // Hide the warning message after 3 seconds
            }, 3000);
            event.preventDefault(); // Prevent entering the exceeded character
        }
    }
  }

  isNameLimitReached(fieldName: string): boolean {
    return this.NamecharacterLimitReached[fieldName];
  }


  //Password validation
  containsUppercase(value: string): boolean {
    return /[A-Z]/.test(value);
  }
  
  containsLowercase(value: string): boolean {
    return /[a-z]/.test(value);
  }
  
  containsDigit(value: string): boolean {
    return /\d/.test(value);
  }
  
  containsSpecialCharacter(value: string): boolean {
    return /[!@#$%^&*]/.test(value);
  }
}



// WEBPACK FOOTER //
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/register/register.component.ts